import { format, isToday } from "date-fns";

/**
 * When a message in a thread was sent: the time alone for today, and the day
 * too for anything earlier, so yesterday's message does not read as today's.
 */
export const formatMessageTime = (value: string | Date) => {
  const date = new Date(value);
  return isToday(date) ? format(date, "h:mm a") : format(date, "MMM d, h:mm a");
};
